// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__99Q-a","colBig":"styles_colBig__35c4r","colSmall":"styles_colSmall__2k6-T"};